import { render } from "./TemplatePRX.vue?vue&type=template&id=cf4bc16c"
import script from "./TemplatePRX.vue?vue&type=script&lang=js"
export * from "./TemplatePRX.vue?vue&type=script&lang=js"
script.render = render

export default script